/**
 * EditorAnnotation type identifiers
 */
export enum EditorAnnotationType {
  Box = "box",
  Point = "point",
}

export interface EditorAnnotation {
  id: string;
  type: EditorAnnotationType;
  x: number; // normalized coordinate NORMALIZED_BOUNDS.MIN to NORMALIZED_BOUNDS.MAX
  y: number; // normalized coordinate NORMALIZED_BOUNDS.MIN to NORMALIZED_BOUNDS.MAX
  width?: number; // normalized dimension NORMALIZED_BOUNDS.MIN to NORMALIZED_BOUNDS.MAX (only for box)
  height?: number; // normalized dimension NORMALIZED_BOUNDS.MIN to NORMALIZED_BOUNDS.MAX (only for box)
  label: string;
  mediaSetId?: string;
  mediaKey?: string;
}

// Helper functions for type-safe annotation creation
export const createBoxAnnotation = (
  props: Omit<EditorAnnotation, "id" | "type" | "width" | "height"> & { width: number; height: number },
): Omit<EditorAnnotation, "id"> => ({
  ...props,
  type: EditorAnnotationType.Box,
  width: props.width,
  height: props.height,
});

export const createPointAnnotation = (
  props: Omit<EditorAnnotation, "id" | "type" | "width" | "height">,
): Omit<EditorAnnotation, "id"> => ({
  ...props,
  type: EditorAnnotationType.Point,
});
